import { ChargeWaiverRegistrationConstant, ChargeWaiverRegistrationRequiredFieldList } from "presentation/constant/ChargeWaiverRegistration/ChargeWaiverRegistrationConstant";
import { useChargeWaiverRegistrationVM } from "presentation/hook/ChargeWaiverRegistration/useChargeWaiverRegistrationVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeWaiverRegistrationTracked } from "presentation/store/ChargeWaiverRegistration/ChargeWaiverRegistrationProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ChargeWaiverRegistrationEditPanel = () => {
    const SCREEN_CONSTANT = ChargeWaiverRegistrationConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [chargeWaiverRegistrationState] = useChargeWaiverRegistrationTracked();
    const chargeWaiverRegistrationVM = useChargeWaiverRegistrationVM();
    const { currentEditRow, isAdd, isEdit, masterState, dynamicOptions } = chargeWaiverRegistrationState;
    const { isSaveClicked, allFormState } = masterState;
    const { waiverReasonCodeDropdownOptions } = dynamicOptions;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;

    const handleSave = useCallback(async () => {
        // if (!currentEditRow.waiverReasonCode) {
        //     messageBarVM.showError("Waiver Reason Code is Mandatory.");
        //     return;
        // }

        if (currentEditRow.waiverReasonCode && !waiverReasonCodeDropdownOptions?.some(e => e.value === currentEditRow.waiverReasonCode)) {
            messageBarVM.showError("Invalid Waiver Reason Code.");
            return;
        }

        setIsLoading(true);
        chargeWaiverRegistrationVM.onSaveClicked();
        await chargeWaiverRegistrationVM.onSave(currentEditRow).then(data => {
            if (data && data.success) {
                chargeWaiverRegistrationVM.onSearch().then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                data.data && messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, messageBarVM, chargeWaiverRegistrationVM, waiverReasonCodeDropdownOptions]);

    const handClose = useCallback(() => {
        chargeWaiverRegistrationVM.onCloseEidtPanel();
    }, [chargeWaiverRegistrationVM]);


    const memoSubChgTypeOptions = useMemo(() => {
        const subChgTypeOptions = currentEditRow.chargeType ? chargeWaiverRegistrationState.dynamicOptions.subChargeTypeDropdownOptions[currentEditRow.chargeType] : [];
        return subChgTypeOptions;
    }, [currentEditRow.chargeType, chargeWaiverRegistrationState.dynamicOptions.subChargeTypeDropdownOptions])

    // const memochargeDesc = useMemo(() => {
    //     const deskKey = currentEditRow.chargeType + "-" + (currentEditRow.subChargeType ?? "null");
    //     return chargeDescMap[deskKey] ?? "";
    // }, [currentEditRow.chargeType, currentEditRow.subChargeType, chargeDescMap])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeType || ''}
                fieldValue={currentEditRow?.chargeType}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                maxLength={60}
                options={chargeWaiverRegistrationState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={ChargeWaiverRegistrationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeWaiverRegistrationVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CHARGE_TYPE, allFormState, chargeWaiverRegistrationState.dynamicOptions.chargeTypeDropdownOptions, chargeWaiverRegistrationVM, currentEditRow?.chargeType, isAdd, isEdit, isSaveClicked])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.subChargeType || ''}
                fieldValue={currentEditRow?.subChargeType}
                fieldLabel={SCREEN_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={60}
                options={memoSubChgTypeOptions}
                requiredFieldList={ChargeWaiverRegistrationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeWaiverRegistrationVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SUB_CHARGE_TYPE, allFormState, chargeWaiverRegistrationVM, currentEditRow?.subChargeType, isAdd, isEdit, isSaveClicked, memoSubChgTypeOptions])


    const memoWaiverReasonCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow.waiverReasonCode ?? ""}
                fieldValue={currentEditRow?.waiverReasonCode ?? ""}
                fieldLabel={SCREEN_CONSTANT.WAIVER_REASON_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'waiverReasonCode'}
                maxLength={60}
                options={chargeWaiverRegistrationState.dynamicOptions.waiverReasonCodeDropdownOptions}
                requiredFieldList={ChargeWaiverRegistrationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeWaiverRegistrationVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow.waiverReasonCode, SCREEN_CONSTANT.WAIVER_REASON_CODE, isSaveClicked, chargeWaiverRegistrationState.dynamicOptions.waiverReasonCodeDropdownOptions, chargeWaiverRegistrationVM])


    const memoChargeDescription = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1010px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEditRow.chargeDescription ?? ""}
                fieldValue={currentEditRow.chargeDescription ?? ""}
                fieldLabel={SCREEN_CONSTANT.CHARGE_DESCRIPTION}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeDescription'}
                maxLength={60}
                requiredFieldList={ChargeWaiverRegistrationRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeWaiverRegistrationVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentEditRow.chargeDescription, SCREEN_CONSTANT.CHARGE_DESCRIPTION, isSaveClicked, chargeWaiverRegistrationVM])


    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={ChargeWaiverRegistrationRequiredFieldList}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => chargeWaiverRegistrationVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEditRow?.activeInd, isAdd, isEdit, chargeWaiverRegistrationVM])

    const handleEdit = useCallback(() => {
        chargeWaiverRegistrationVM.onEditClick();
    }, [chargeWaiverRegistrationVM]);

    const handleReset = useCallback(() => {
        chargeWaiverRegistrationVM.onResetClick(isAdd);
    }, [chargeWaiverRegistrationVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Charge Waiver Registration"}
                                    {!isAdd && currentEditRow.waiverReasonCode}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>


                        <CriteriaItemContainer>
                            {memoWaiverReasonCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSubChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeDescription}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default ChargeWaiverRegistrationEditPanel;
